import EditNotesForm from '@patientMenu/form/EditNotesForm';
import { ModalFormWrapper } from '@/components/ui/ModalFormWrapper';
import { JawsScanUpdate } from '@schema/jawsScan.ts';
import { useJawsScanSummary, useUpdateJawsScan } from '@hooks/useJawsScan.ts';
import { useParams } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { useEffect } from 'react';

export default function EditNotes({ onClose }: { onClose: () => void }) {
  const { scanId } = useParams<{ scanId: string }>();
  const scanQuery = useJawsScanSummary(scanId!);
  const scanMut = useUpdateJawsScan(scanId!);

  const form = useForm<JawsScanUpdate>({});

  const handleSubmit = (data: JawsScanUpdate) => {
    scanMut.mutate(data, {
      onSuccess: () => {
        form.reset();
        onClose();
      },
      onError: (error) => {
        console.error('Error updating scan:', error);
      },
    });
  };

  useEffect(() => {
    if (scanQuery.data) {
      form.reset({
        note: scanQuery.data.note,
      });
    }
  }, [scanQuery.data, form]);

  if (scanQuery.isLoading) {
    return null;
  }

  return (
    <ModalFormWrapper form={form} submitText="Save" submitButton="default" onSubmit={handleSubmit} onClose={onClose}>
      <EditNotesForm />
    </ModalFormWrapper>
  );
}
